import React from 'react'
import { createRoot } from 'react-dom/client';
import './index.css'
import App from './App'
import { firebaseConfig, setupHelpers } from "./libs/firebase";
import { firebaseHelper } from 'ui';

firebaseHelper.initializeApp(firebaseConfig);
setupHelpers();

const useStaging = !    (window.location.hostname.includes('mattoboard.com')
						            || window.location.hostname.includes('web.app'))

// Lazy load Sentry
const initializeSentry = async () => {
  try {
    const Sentry = await import("@sentry/react");

    Sentry.init({
      dsn: "https://5c18a30196a940c9ade7515923c03671@o1220868.ingest.sentry.io/6367335",
      tracesSampleRate: 0.1,
      autoSessionTracking: false,
      enabled: true,
      environment: useStaging ? 'staging' : 'production',
    });
  } catch (error) {
    console.warn('Failed to initialize Sentry:', error);
  }
};

const container = document.getElementById('root');
const root = createRoot(container);
// newer version uses React18
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Initialize Sentry after the app has rendered
initializeSentry();
